const getTheeSixtyEvaluationState = () => ({
	jobs: [],
	jobAreas: [],
	moduleConfiguration: {
		steps: {
			firstStep: {},
			dynamicSteps: [],
			lastStep: {},
		},
		videoUrl: '',
		fileUrl: 'https://go.microsoft.com/fwlink/?LinkID=521962',
	},
	evaluationFlow: {
		currentStep: 1,
		selectedAreaIds: [],
		selectedJobs: [],
	},
});

export default getTheeSixtyEvaluationState;



// WEBPACK FOOTER //
// ./src/modules/three-sixty-evaluation/store/state.js